import { getConfigValue } from '@/shared/config/utils';

export function getMaxSessionDurationSeconds() {
    return getConfigValue('MAX_DICTATION_SESSION_DURATION_SECONDS');
}
